export const getCookie = (name: string) => {
  const pairs = document.cookie.split(';');
  for (let pair of pairs) {
    pair = pair.trim();
    const [cookieName, cookieValue] = pair.split('=');
    if (cookieName.trim() === name) {
      return cookieValue.trim();
    }
  }
  return null;
};
